module.exports = __webpack_public_path__ + "calendar-tag.png?1c3ae29e8b0cd1768203e61ce6b9158a";